export const PERMISSION_REGISTRY = {
    'platform:provider-ingestion:read': {
        id: 'platform:provider-ingestion:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read provider ingestion controls and lineage',
    },
    'platform:provider-ingestion:manage': {
        id: 'platform:provider-ingestion:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Manage provider ingestion controls and feed processing',
    },
    'platform:reference-master:read': {
        id: 'platform:reference-master:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read governed reference master versions',
    },
    'platform:reference-master:manage': {
        id: 'platform:reference-master:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Manage governed reference master versions',
    },
    'platform:jurisdiction-packages:read': {
        id: 'platform:jurisdiction-packages:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read governed jurisdiction package lifecycle records',
    },
    'platform:jurisdiction-packages:manage': {
        id: 'platform:jurisdiction-packages:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Manage governed jurisdiction package lifecycle records',
    },
    // Hub-level navigation
    'data:hub': {
        id: 'data:hub',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Access data hub entrypoint',
    },
    'admin:hub': {
        id: 'admin:hub',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Access admin hub entrypoint',
    },
    'access:permissions:read': {
        id: 'access:permissions:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform permissions for the platform access inspector',
    },
    'access:members:read': {
        id: 'access:members:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization members for access inspector',
    },
    'admin.users.view': {
        id: 'admin.users.view',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'View users admin list page',
    },
    'admin:user:create': {
        id: 'admin:user:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create user via admin',
    },
    'admin:user:update': {
        id: 'admin:user:update',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Update user via admin',
    },
    'admin:user:delete': {
        id: 'admin:user:delete',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Delete user via admin',
    },
    'admin.roles.view': {
        id: 'admin.roles.view',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'View roles admin list page',
    },
    'admin:role:create': {
        id: 'admin:role:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create role via admin',
    },
    'admin:role:update': {
        id: 'admin:role:update',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Update role via admin',
    },
    'admin:role:delete': {
        id: 'admin:role:delete',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Delete role via admin',
    },
    'admin.organization.view': {
        id: 'admin.organization.view',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'View organization admin page',
    },
    'admin.audit.view': {
        id: 'admin.audit.view',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'View audit explorer',
    },
    'admin:auditLog:view': {
        id: 'admin:auditLog:view',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List audit log entries',
    },
    // Auth self-service
    'auth:profile:read': {
        id: 'auth:profile:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read own profile',
    },
    'auth:logout': {
        id: 'auth:logout',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'End the current authenticated session',
    },
    'auth:context:switch': {
        id: 'auth:context:switch',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Switch the active organization or branch context',
    },
    'auth:password:change': {
        id: 'auth:password:change',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Change own password',
    },
    'auth:sessions': {
        id: 'auth:sessions',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'View and manage own sessions',
    },
    'navigation:read': {
        id: 'navigation:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read navigation shell, routes, and hubs',
    },
    // Platform
    'platform:organizations:list': {
        id: 'platform:organizations:list',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'List platform organizations metadata',
    },
    'platform:organizations:read': {
        id: 'platform:organizations:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform organization metadata',
    },
    'platform:organizations:create': {
        id: 'platform:organizations:create',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create platform organizations',
    },
    'platform:organizations:update': {
        id: 'platform:organizations:update',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Update platform organizations',
    },
    'platform:organizations:disable': {
        id: 'platform:organizations:disable',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Disable platform organizations',
    },
    'platform:organizations:offboarding-export': {
        id: 'platform:organizations:offboarding-export',
        authority: 'PLATFORM',
        resourceScope: 'SYSTEM',
        description: 'Export encrypted organization offboarding bundles',
    },
    'platform:organizations:onboarding-readiness': {
        id: 'platform:organizations:onboarding-readiness',
        authority: 'PLATFORM',
        resourceScope: 'SYSTEM',
        description: 'Read organization onboarding readiness status',
    },
    'platform:organizations:support-command:issue': {
        id: 'platform:organizations:support-command:issue',
        authority: 'PLATFORM',
        resourceScope: 'SYSTEM',
        description: 'Issue a support command to an organization runtime',
    },
    'platform:modules:list': {
        id: 'platform:modules:list',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'List platform modules',
    },
    'platform:modules:read': {
        id: 'platform:modules:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform modules',
    },
    'platform:view:modules': {
        id: 'platform:view:modules',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform module entitlements',
    },
    'platform:manage:modules': {
        id: 'platform:manage:modules',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Enable or disable platform modules',
    },
    'platform:modules:assign': {
        id: 'platform:modules:assign',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Assign platform modules to organizations',
    },
    'platform:view:licenses': {
        id: 'platform:view:licenses',
        authority: 'PLATFORM',
        resourceScope: 'SYSTEM',
        description: 'Read commercial module license terms',
    },
    'platform:manage:licenses': {
        id: 'platform:manage:licenses',
        authority: 'PLATFORM',
        resourceScope: 'SYSTEM',
        description: 'Create and renew commercial module license terms',
    },
    'platform:modules:revoke': {
        id: 'platform:modules:revoke',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Revoke platform modules from organizations',
    },
    'platform:users:list': {
        id: 'platform:users:list',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'List platform users',
    },
    'platform:users:read': {
        id: 'platform:users:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform users',
    },
    'platform:users:create': {
        id: 'platform:users:create',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create platform users',
    },
    'platform:users:update': {
        id: 'platform:users:update',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Update platform users',
    },
    'platform:users:disable': {
        id: 'platform:users:disable',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Disable platform users',
    },
    'platform:users:email:view': {
        id: 'platform:users:email:view',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'View platform user email addresses (PII)',
    },
    'platform:audit:read': {
        id: 'platform:audit:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform audit logs',
    },
    'platform:audit:list': {
        id: 'platform:audit:list',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'List platform audit entries',
    },
    'platform:audit:export': {
        id: 'platform:audit:export',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Export platform audit entries',
    },
    'platform:audit:user-email:view': {
        id: 'platform:audit:user-email:view',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'View actor email addresses in platform audit entries (PII)',
    },
    'platform:reports:snapshot:create': {
        id: 'platform:reports:snapshot:create',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create retained platform operational report snapshots',
    },
    'platform:reports:restatement:create': {
        id: 'platform:reports:restatement:create',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create linked platform report restatements',
    },
    'platform:configuration-rollout:read': {
        id: 'platform:configuration-rollout:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform configuration rollout state',
    },
    'platform:configuration-rollout:manage': {
        id: 'platform:configuration-rollout:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Validate, stage, and rollback platform configuration',
    },
    'platform:data-residency:read': {
        id: 'platform:data-residency:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform data residency policies and transfer evidence',
    },
    'platform:data-residency:policy:update': {
        id: 'platform:data-residency:policy:update',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Update platform data residency policy',
    },
    'platform:data-residency:transfer:evaluate': {
        id: 'platform:data-residency:transfer:evaluate',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Evaluate governed cross-region data transfers',
    },
    'platform:data-residency:exception:approve': {
        id: 'platform:data-residency:exception:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Approve time-bounded data residency exceptions',
    },
    'platform:health:read': {
        id: 'platform:health:read',
        authority: 'PLATFORM',
        resourceScope: 'SYSTEM',
        description: 'Read platform health',
    },
    'platform:admin:security-posture:read': {
        id: 'platform:admin:security-posture:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform security posture',
    },
    'platform:admin:data-provider-health:read': {
        id: 'platform:admin:data-provider-health:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform data-provider health',
    },
    'platform:admin:maintenance-delegations:read': {
        id: 'platform:admin:maintenance-delegations:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform maintenance delegations',
    },
    'platform:admin:maintenance-delegations:manage': {
        id: 'platform:admin:maintenance-delegations:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create platform maintenance delegations',
    },
    'platform:admin:maintenance-delegations:approve': {
        id: 'platform:admin:maintenance-delegations:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Approve platform maintenance delegations',
    },
    'platform:admin:maintenance-delegations:revoke': {
        id: 'platform:admin:maintenance-delegations:revoke',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Revoke platform maintenance delegations',
    },
    'platform:market-data:override': {
        id: 'platform:market-data:override',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Override platform market data',
    },
    'platform:market-data-quality:read': {
        id: 'platform:market-data-quality:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read market-data quality cases',
    },
    'platform:market-data-quality:manage': {
        id: 'platform:market-data-quality:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Investigate and correct market-data quality cases',
    },
    'platform:market-data-quality:approve': {
        id: 'platform:market-data-quality:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Independently approve market-data quality releases',
    },
    'platform:issuer-events:read': {
        id: 'platform:issuer-events:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read authoritative issuer-event versions',
    },
    'platform:issuer-events:manage': {
        id: 'platform:issuer-events:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Submit, resolve, revise, and cancel issuer events',
    },
    'platform:issuer-events:approve': {
        id: 'platform:issuer-events:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Independently approve issuer-event publication',
    },
    'platform:permission-catalog-migrations:read': {
        id: 'platform:permission-catalog-migrations:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read permission catalog migration previews and history',
    },
    'platform:permission-catalog-migrations:manage': {
        id: 'platform:permission-catalog-migrations:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Activate and roll back safe permission catalog migrations',
    },
    'platform:migration-governance:read': {
        id: 'platform:migration-governance:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read governed schema, data, and rule migration evidence',
    },
    'platform:migration-governance:request': {
        id: 'platform:migration-governance:request',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Preview, execute, and request rollback of governed platform migrations',
    },
    'platform:migration-governance:approve': {
        id: 'platform:migration-governance:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Independently approve governed platform migrations and rollbacks',
    },
    'platform:organization-portability:read': {
        id: 'platform:organization-portability:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read organization portability package manifests and receipt state',
    },
    'platform:organization-portability:request': {
        id: 'platform:organization-portability:request',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Request, transfer, acknowledge, and validate organization portability packages',
    },
    'platform:organization-portability:approve': {
        id: 'platform:organization-portability:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Independently approve organization portability package generation',
    },
    'platform:organization-portability:purge': {
        id: 'platform:organization-portability:purge',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Purge transferred organization portability package ciphertext after validation',
    },
    'platform:notification-governance:read': {
        id: 'platform:notification-governance:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform notification templates, recipient policies, and delivery evidence',
    },
    'platform:notification-governance:manage': {
        id: 'platform:notification-governance:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create platform notification templates, recipient policies, and dispatch requests',
    },
    'platform:notification-governance:approve': {
        id: 'platform:notification-governance:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Independently approve platform notification templates and recipient policies',
    },
    'platform:federation:read': {
        id: 'platform:federation:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read federation configuration and provisioning history',
    },
    'platform:federation:manage': {
        id: 'platform:federation:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Manage federation configuration and deprovisioning',
    },
    'platform:service-accounts:read': {
        id: 'platform:service-accounts:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read machine identities and credential fingerprints',
    },
    'platform:service-accounts:manage': {
        id: 'platform:service-accounts:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create, rotate, and revoke machine identities and credentials',
    },
    'platform:access-reviews:read': {
        id: 'platform:access-reviews:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read access recertification campaigns',
    },
    'platform:access-reviews:manage': {
        id: 'platform:access-reviews:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create and decide access recertification campaigns',
    },
    'platform:cryptographic-keys:read': {
        id: 'platform:cryptographic-keys:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read non-secret cryptographic key lifecycle metadata',
    },
    'platform:cryptographic-keys:manage': {
        id: 'platform:cryptographic-keys:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Rotate and revoke cryptographic key versions',
    },
    'platform:scheduled-controls:read': {
        id: 'platform:scheduled-controls:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read redacted Platform Root scheduled-control history',
    },
    'platform:scheduled-controls:manage': {
        id: 'platform:scheduled-controls:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Request bounded scheduled-control reruns, backfills, and cancellation',
    },
    'platform:scheduled-controls:approve': {
        id: 'platform:scheduled-controls:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Independently approve scheduled-control mutations',
    },
    'platform:security-incidents:read': {
        id: 'platform:security-incidents:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read redacted security incident records and timelines',
    },
    'platform:security-incidents:manage': {
        id: 'platform:security-incidents:manage',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Declare and request bounded containment for security incidents',
    },
    'platform:organization-ownership:read': {
        id: 'platform:organization-ownership:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read governed organization ownership transitions',
    },
    'platform:organization-ownership:request': {
        id: 'platform:organization-ownership:request',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Request governed organization ownership transfer or emergency recovery',
    },
    'platform:organization-ownership:approve': {
        id: 'platform:organization-ownership:approve',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Independently approve governed organization ownership transitions',
    },
    'platform:market-data:providers:read': {
        id: 'platform:market-data:providers:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform market-data providers',
    },
    'platform:market-data:exceptions:read': {
        id: 'platform:market-data:exceptions:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read platform market-data exceptions',
    },
    'platform:support-delegations:list': {
        id: 'platform:support-delegations:list',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'List support delegations',
    },
    'platform:support-delegations:read': {
        id: 'platform:support-delegations:read',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Read support delegation',
    },
    'platform:support-delegations:create': {
        id: 'platform:support-delegations:create',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Create support delegation',
    },
    'platform:support-delegations:update': {
        id: 'platform:support-delegations:update',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Update support delegation',
    },
    'platform:support-delegations:revoke': {
        id: 'platform:support-delegations:revoke',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Revoke support delegation',
    },
    'platform:support-delegations:enter': {
        id: 'platform:support-delegations:enter',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Enter an approved support delegation',
    },
    'platform:support-delegations:exit': {
        id: 'platform:support-delegations:exit',
        authority: 'PLATFORM',
        resourceScope: 'PLATFORM',
        description: 'Exit an active support delegation',
    },
    // Organization administration
    'organization:profile:read': {
        id: 'organization:profile:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization profile',
    },
    'organization:profile:update': {
        id: 'organization:profile:update',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Update organization profile',
    },
    'organization:branches:list': {
        id: 'organization:branches:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization branchs',
    },
    'organization:branches:read': {
        id: 'organization:branches:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization branch',
    },
    'organization:branches:create': {
        id: 'organization:branches:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create organization branch',
    },
    'organization:branches:update': {
        id: 'organization:branches:update',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Update organization branch',
    },
    'organization:branches:disable': {
        id: 'organization:branches:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Disable organization branch',
    },
    'organization:modules:list': {
        id: 'organization:modules:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization modules',
    },
    'organization:modules:enable': {
        id: 'organization:modules:enable',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Enable organization module',
    },
    'organization:modules:disable': {
        id: 'organization:modules:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Disable organization module',
    },
    'organization:modules:configure': {
        id: 'organization:modules:configure',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Configure organization module',
    },
    'organization:users:list': {
        id: 'organization:users:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization users',
    },
    'organization:users:read': {
        id: 'organization:users:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization user',
    },
    'organization:users:create': {
        id: 'organization:users:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create organization user',
    },
    'organization:users:update': {
        id: 'organization:users:update',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Update organization user',
    },
    'organization:users:disable': {
        id: 'organization:users:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Disable organization user',
    },
    'organization:users:unlock': {
        id: 'organization:users:unlock',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Unlock organization user',
    },
    'organization:users:force-password-reset': {
        id: 'organization:users:force-password-reset',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Force an organization user password reset',
    },
    'organization:users:mfa:require-enrollment': {
        id: 'organization:users:mfa:require-enrollment',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Require MFA enrollment for an organization user',
    },
    'organization:users:mfa:reset-enrollment': {
        id: 'organization:users:mfa:reset-enrollment',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Reset MFA enrollment for an organization user',
    },
    'organization:users:mfa:disable': {
        id: 'organization:users:mfa:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Disable MFA for an organization user',
    },
    'organization:users:mfa:regenerate-recovery': {
        id: 'organization:users:mfa:regenerate-recovery',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Regenerate MFA recovery codes for an organization user',
    },
    'organization:users:email:view': {
        id: 'organization:users:email:view',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'View organization user email addresses (PII)',
    },
    'organization:roles:list': {
        id: 'organization:roles:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization roles',
    },
    'organization:roles:read': {
        id: 'organization:roles:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization role',
    },
    'organization:roles:create': {
        id: 'organization:roles:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create organization role',
    },
    'organization:roles:update': {
        id: 'organization:roles:update',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Update organization role',
    },
    'organization:roles:disable': {
        id: 'organization:roles:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Disable organization role',
    },
    'organization:permissions:list': {
        id: 'organization:permissions:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization permissions',
    },
    'organization:permissions:assign': {
        id: 'organization:permissions:assign',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Assign organization permissions',
    },
    'organization:permissions:revoke': {
        id: 'organization:permissions:revoke',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Revoke organization permissions',
    },
    'organization:permission-assignments:list': {
        id: 'organization:permission-assignments:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization permission assignments',
    },
    'organization:permission-assignments:edit': {
        id: 'organization:permission-assignments:edit',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Edit organization permission assignments',
    },
    'organization:clients:list': {
        id: 'organization:clients:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List clients in organization',
    },
    'organization:clients:read': {
        id: 'organization:clients:read',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Read client in organization',
    },
    'organization:clients:create': {
        id: 'organization:clients:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create client in organization',
    },
    'organization:clients:update': {
        id: 'organization:clients:update',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Update client in organization',
    },
    'organization:clients:disable': {
        id: 'organization:clients:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Disable client in organization',
    },
    'organization:client-accounts:list': {
        id: 'organization:client-accounts:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List client accounts',
    },
    'organization:client-accounts:read': {
        id: 'organization:client-accounts:read',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Read client account',
    },
    'organization:client-accounts:create': {
        id: 'organization:client-accounts:create',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Create client account',
    },
    'organization:client-accounts:update': {
        id: 'organization:client-accounts:update',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Update client account',
    },
    'organization:client-accounts:disable': {
        id: 'organization:client-accounts:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Disable (soft-delete) client account',
    },
    'organization:portfolios:list': {
        id: 'organization:portfolios:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List portfolios',
    },
    'organization:portfolios:read': {
        id: 'organization:portfolios:read',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Read portfolio',
    },
    'organization:accounting:read': {
        id: 'organization:accounting:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read accounting journals, fiscal periods, and chart of accounts',
    },
    'organization:accounting:manage': {
        id: 'organization:accounting:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage accounting journals, fiscal periods, and chart of accounts',
    },
    'organization:portfolios:create': {
        id: 'organization:portfolios:create',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Create portfolio',
    },
    'organization:portfolios:update': {
        id: 'organization:portfolios:update',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Update portfolio',
    },
    'organization:portfolios:disable': {
        id: 'organization:portfolios:disable',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Disable (soft-delete) portfolio',
    },
    'organization:audit:read': {
        id: 'organization:audit:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization audit',
    },
    'organization:audit:list': {
        id: 'organization:audit:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization audit entries',
    },
    'organization:audit:export': {
        id: 'organization:audit:export',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Export organization audit entries',
    },
    'organization:audit:user-email:view': {
        id: 'organization:audit:user-email:view',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'View actor email addresses in organization audit entries (PII)',
    },
    'organization:access-inspector:read': {
        id: 'organization:access-inspector:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization access inspector diagnostics',
    },
    'organization:legal-hold:list': {
        id: 'organization:legal-hold:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization legal holds',
    },
    'organization:legal-hold:place': {
        id: 'organization:legal-hold:place',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Place an organization legal hold',
    },
    'organization:legal-hold:remove': {
        id: 'organization:legal-hold:remove',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Remove an organization legal hold',
    },
    'organization:admin-delegation:list': {
        id: 'organization:admin-delegation:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List organization administrator delegations',
    },
    'organization:admin-delegation:create': {
        id: 'organization:admin-delegation:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create organization administrator delegations',
    },
    'organization:admin-delegation:revoke': {
        id: 'organization:admin-delegation:revoke',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Revoke organization administrator delegations',
    },
    'organization:settlement:read': {
        id: 'organization:settlement:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization settlement instructions',
    },
    'organization:settlement:create': {
        id: 'organization:settlement:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create organization settlement instructions',
    },
    'organization:settlement:confirm': {
        id: 'organization:settlement:confirm',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Confirm organization settlement instructions',
    },
    'organization:settlement:correct': {
        id: 'organization:settlement:correct',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Correct organization settlement instructions',
    },
    'organization:settlement:cancel': {
        id: 'organization:settlement:cancel',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Cancel organization settlement instructions',
    },
    'organization:position-transfers:read': {
        id: 'organization:position-transfers:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization position transfers',
    },
    'organization:position-transfers:request': {
        id: 'organization:position-transfers:request',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Request organization position transfers',
    },
    'organization:position-transfers:approve': {
        id: 'organization:position-transfers:approve',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Approve organization position transfers',
    },
    'organization:position-transfers:execute': {
        id: 'organization:position-transfers:execute',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Execute organization position transfers',
    },
    'organization:position-transfers:cancel': {
        id: 'organization:position-transfers:cancel',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Cancel organization position transfers',
    },
    'organization:position-transfers:reverse': {
        id: 'organization:position-transfers:reverse',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Reverse organization position transfers',
    },
    'organization:evidence:read': {
        id: 'organization:evidence:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization evidence',
    },
    'organization:admin:permission-bundles:read': {
        id: 'organization:admin:permission-bundles:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization permission bundles',
    },
    'organization:admin:permission-bundles:manage': {
        id: 'organization:admin:permission-bundles:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization permission bundles',
    },
    'organization:admin:approval-policies:read': {
        id: 'organization:admin:approval-policies:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization approval policies',
    },
    'organization:admin:approval-policies:manage': {
        id: 'organization:admin:approval-policies:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization approval policies',
    },
    'organization:admin:retention:read': {
        id: 'organization:admin:retention:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization retention policies',
    },
    'organization:admin:retention:manage': {
        id: 'organization:admin:retention:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization retention policies',
    },
    'organization:admin:export:read': {
        id: 'organization:admin:export:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization export policies',
    },
    'organization:admin:export:manage': {
        id: 'organization:admin:export:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization export policies',
    },
    'organization:admin:security:read': {
        id: 'organization:admin:security:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization security settings',
    },
    'organization:admin:security:manage': {
        id: 'organization:admin:security:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization security settings',
    },
    'organization:admin:regulatory:read': {
        id: 'organization:admin:regulatory:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization regulatory profile',
    },
    'organization:admin:regulatory:manage': {
        id: 'organization:admin:regulatory:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization regulatory profile',
    },
    'organization:admin:jurisdiction:read': {
        id: 'organization:admin:jurisdiction:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization jurisdiction settings',
    },
    'organization:admin:jurisdiction:manage': {
        id: 'organization:admin:jurisdiction:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization jurisdiction settings',
    },
    'organization:admin:support-access:read': {
        id: 'organization:admin:support-access:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization support-access settings',
    },
    'organization:admin:support-access:manage': {
        id: 'organization:admin:support-access:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization support-access settings',
    },
    // Investment and client-safe business permissions
    'organization:dashboard:read': {
        id: 'organization:dashboard:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read dashboard',
    },
    'organization:transactions:list': {
        id: 'organization:transactions:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List transactions',
    },
    'organization:transactions:export': {
        id: 'organization:transactions:export',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Export organization transactions',
    },
    'organization:transactions:read': {
        id: 'organization:transactions:read',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Read transaction',
    },
    'organization:transactions:create': {
        id: 'organization:transactions:create',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Create transaction',
    },
    'organization:transactions:update': {
        id: 'organization:transactions:update',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Update transaction',
    },
    'organization:transactions:approve': {
        id: 'organization:transactions:approve',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Approve transaction',
    },
    'organization:transactions:post': {
        id: 'organization:transactions:post',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Post transaction',
    },
    'organization:holdings:read': {
        id: 'organization:holdings:read',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Read holdings',
    },
    'organization:reports:read': {
        id: 'organization:reports:read',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Read reports',
    },
    'organization:reports:export': {
        id: 'organization:reports:export',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Export reports',
    },
    'organization:reports:list': {
        id: 'organization:reports:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List reports',
    },
    'organization:reports:run': {
        id: 'organization:reports:run',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Run reports',
    },
    'organization:market-data:read': {
        id: 'organization:market-data:read',
        authority: 'ORGANIZATION',
        resourceScope: 'PLATFORM',
        description: 'Read market data',
    },
    'organization:reports:schedule': {
        id: 'organization:reports:schedule',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Schedule reports',
    },
    'organization:imports:list': {
        id: 'organization:imports:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List imports',
    },
    'organization:imports:upload': {
        id: 'organization:imports:upload',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Upload imports',
    },
    'organization:imports:commit': {
        id: 'organization:imports:commit',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Commit imports',
    },
    'organization:imports:validate': {
        id: 'organization:imports:validate',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Validate imports',
    },
    'organization:imports:preview': {
        id: 'organization:imports:preview',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Preview imports',
    },
    'organization:imports:cancel': {
        id: 'organization:imports:cancel',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Cancel imports',
    },
    'organization:imports:retry': {
        id: 'organization:imports:retry',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Retry imports',
    },
    'organization:reconciliation:list': {
        id: 'organization:reconciliation:list',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'List reconciliation runs',
    },
    'organization:reconciliation:manage': {
        id: 'organization:reconciliation:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage reconciliation',
    },
    'organization:reconciliation:read': {
        id: 'organization:reconciliation:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read reconciliation run',
    },
    'organization:reconciliation:create': {
        id: 'organization:reconciliation:create',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Create reconciliation run',
    },
    'organization:reconciliation:match': {
        id: 'organization:reconciliation:match',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Match reconciliation items',
    },
    'organization:reconciliation:resolve': {
        id: 'organization:reconciliation:resolve',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Resolve reconciliation exceptions',
    },
    'organization:reconciliation:complete': {
        id: 'organization:reconciliation:complete',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Complete reconciliation run',
    },
    'organization:reconciliation:reopen': {
        id: 'organization:reconciliation:reopen',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Reopen reconciliation run',
    },
    'organization:reconciliation:export': {
        id: 'organization:reconciliation:export',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Export reconciliation results',
    },
    'organization:instruments:read': {
        id: 'organization:instruments:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read instruments',
    },
    'organization:instruments:manage': {
        id: 'organization:instruments:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage instruments',
    },
    'organization:market-data:manage': {
        id: 'organization:market-data:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Legacy market-data mutation permission; not assigned to default personas',
    },
    'security-master:destructive-delete': {
        id: 'security-master:destructive-delete',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Destructive canonical instrument deletion; not assigned to default personas',
    },
    'organization:transactions:submit': {
        id: 'organization:transactions:submit',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Submit transaction',
    },
    'organization:transactions:reject': {
        id: 'organization:transactions:reject',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Reject transaction',
    },
    'organization:transactions:withdraw': {
        id: 'organization:transactions:withdraw',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Withdraw transaction',
    },
    'organization:transactions:repair': {
        id: 'organization:transactions:repair',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Repair transaction',
    },
    'organization:transactions:repost': {
        id: 'organization:transactions:repost',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Repost transaction',
    },
    'organization:transactions:reverse': {
        id: 'organization:transactions:reverse',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Reverse transaction',
    },
    'organization:corporate-actions:read': {
        id: 'organization:corporate-actions:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read corporate actions',
    },
    'organization:corporate-actions:manage': {
        id: 'organization:corporate-actions:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage corporate actions',
    },
    'organization:facts:read': {
        id: 'organization:facts:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read facts',
    },
    'organization:facts:manage': {
        id: 'organization:facts:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage facts',
    },
    'client:dashboard:read': {
        id: 'client:dashboard:read',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Read own dashboard',
    },
    'client:holdings:list-own': {
        id: 'client:holdings:list-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'List own holdings',
    },
    'client:holdings:read-own': {
        id: 'client:holdings:read-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Read own holdings',
    },
    'client:transactions:list-own': {
        id: 'client:transactions:list-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'List own transactions',
    },
    'client:transactions:read-own': {
        id: 'client:transactions:read-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Read own transactions',
    },
    'client:reports:list-own': {
        id: 'client:reports:list-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'List own reports',
    },
    'client:reports:read-own': {
        id: 'client:reports:read-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Read own reports',
    },
    'client:reports:export-own': {
        id: 'client:reports:export-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Export own reports',
    },
    'client:profile:read': {
        id: 'client:profile:read',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Read own client profile',
    },
    'client:profile:limited-update': {
        id: 'client:profile:limited-update',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Update own client profile (limited)',
    },
    'client:documents:read-own': {
        id: 'client:documents:read-own',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Read own documents',
    },
    // Account self-service
    'settings:view': {
        id: 'settings:view',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'View settings hub',
    },
    'settings:profile': {
        id: 'settings:profile',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'View own profile settings',
    },
    'settings:profile:update': {
        id: 'settings:profile:update',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Update own profile settings',
    },
    'settings:preferences': {
        id: 'settings:preferences',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'View own preferences',
    },
    'settings:preferences:update': {
        id: 'settings:preferences:update',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Update own preferences',
    },
    'settings:mfa': {
        id: 'settings:mfa',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'View MFA settings',
    },
    'settings:security': {
        id: 'settings:security',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'View own security overview (credential source, MFA status, sessions)',
    },
    'settings:password:change': {
        id: 'settings:password:change',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Change own password',
    },
    'settings:sessions': {
        id: 'settings:sessions',
        authority: 'CLIENT',
        resourceScope: 'CLIENT',
        description: 'Manage own active sessions',
    },
    'organization:compliance:read': {
        id: 'organization:compliance:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read compliance breaches and investment compliance status',
    },
    'organization:compliance:manage': {
        id: 'organization:compliance:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage confidential compliance governance lifecycles',
    },
    'organization:risk:read': {
        id: 'organization:risk:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read risk exposures and concentration metrics',
    },
    'organization:risk:manage': {
        id: 'organization:risk:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Run risk analyses and resolve risk-limit breaches',
    },
    'organization:governance:read': {
        id: 'organization:governance:read',
        authority: 'ORGANIZATION',
        resourceScope: 'BRANCH',
        description: 'Access the organization governance workspace',
    },
    'organization:privacy:read': {
        id: 'organization:privacy:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read privacy-rights requests and evidence',
    },
    'organization:privacy:manage': {
        id: 'organization:privacy:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage privacy-rights decisions and fulfillment',
    },
    'organization:integrations:read': {
        id: 'organization:integrations:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read organization integration governance state',
    },
    'organization:integrations:manage': {
        id: 'organization:integrations:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage organization integration credentials and messages',
    },
    'organization:monetary-approval:read': {
        id: 'organization:monetary-approval:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read monetary approval authorities and decisions',
    },
    'organization:monetary-approval:manage': {
        id: 'organization:monetary-approval:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage monetary approval authority and commit decisions',
    },
    'organization:client-governance:read': {
        id: 'organization:client-governance:read',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Read client agreements, statements, and complaints',
    },
    'organization:client-governance:manage': {
        id: 'organization:client-governance:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'CLIENT',
        description: 'Manage client agreements, statements, and complaints',
    },
    'organization:tax:read': {
        id: 'organization:tax:read',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Read tax records, CGT facts, and withholding calculations',
    },
    'organization:tax:manage': {
        id: 'organization:tax:manage',
        authority: 'ORGANIZATION',
        resourceScope: 'ORGANIZATION',
        description: 'Manage tax rules, including lifecycle transitions and version creation',
    },
};
export function isPermissionId(value) {
    return value in PERMISSION_REGISTRY;
}
export function scopeKindToResourceScope(scopeKind) {
    return scopeKind;
}
